<template>
  <teleport to="body">
    <div class="modal" v-if="showModal" @click.self.prevent="showModal != showModal">
      <div class="wrapper">
        <font-awesome-icon icon="fa-xmark" class="exit" @click="closed" />
        <div class="info">
          <label>Station Name:</label>
          <input type="text" v-model="openStation.name" v-if="newStation" placeholder="Station Name..." required />
        </div>
        <div class="action-btns">
          <button @click.stop.prevent="deleteStation" class="button delete">Delete Station</button>
          <button v-if="!newStation" @click.stop.prevent="updateStation" class="button is-primary">Update Station</button>
          <button v-if="newStation" @click.stop.prevent="createStation" class="button is-primary">Create Station</button>
        </div>
      </div>
    </div>
  </teleport>
</template>
<script>
import { api } from "@monolith/helpers";
import { mapGetters } from "vuex";

export default {
  name: "SatelliteStationModal",
  props: ["open", "station", "newStation"],
  emits: ["update", "close"],
  components: {},
  data() {
    return {
      showModal: false,
      openStation: null,
    };
  },
  computed: {
    ...mapGetters({
      channels: "channels",
      siteMap: "siteMap",
      siteSettings: "siteSettings",
    }),
  },
  watch: {
    async open() {
      if (!this.open) {
        this.showModal = false;
        return;
      }
      this.showModal = true;
      this.openStation = this.station;
    },
  },
  methods: {
    closed() {
      this.$emit("close");
      this.showModal = false;
    },
    async createStation() {
      delete this.openStation.active;
      await api.post("/api/company/add_station", { station: this.openStation, station_type: "get_sat" });
      this.$store.dispatch("initialSiteMap");
      // this.$emit("update", "create", "sat", this.openStation);
    },
    async updateStation() {
      delete this.openStation.active;
      this.$emit("update", "update", "sat", this.openStation);
    },
    async deleteStation() {
      this.$emit("update", "delete", "sat", this.openStation);
    },
  },
};
</script>
<style scoped lang="scss">
@use "@monolith/styles";

h3 {
  color: var(--text-colour);
  text-align: center;
  margin: 0.5rem;
}

.active {
  color: var(--action-colour);
}

.discon {
  color: var(--warning-colour);
}



.delete {
  background: var(--warning-colour);
  color: var(--text-colour);
}
.info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 1rem;
  margin: 1rem;
  h4 {
    color: var(--text-colour);
    padding: 0;
    margin: 0;
  }
  input {
    margin: 0 !important;
    border-radius: 0.25rem;
    width: 95%;
    border: none;
    padding: 0.5rem;
  }
  label {
    color: var(--action-colour);
  }
}
.action-btns {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin: 0 auto;
}

.status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 1rem;
  color: var(--text-colour);
}
</style>
